var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHearti = function SvgHearti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Trigger Area"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12 19.116a1.25 1.25 0 0 1-.813-.3l-1.26-1.071a39 39 0 0 1-4.095-3.78 6.3 6.3 0 0 1-1.833-4.177 4.95 4.95 0 0 1 1.237-3.326 4.4 4.4 0 0 1 3.31-1.463 4.48 4.48 0 0 1 3.453 1.651 4.48 4.48 0 0 1 3.453-1.651 4.4 4.4 0 0 1 3.31 1.463 4.95 4.95 0 0 1 1.237 3.326 6.28 6.28 0 0 1-1.834 4.177 38.5 38.5 0 0 1-4.072 3.762l-1.278 1.087a1.26 1.26 0 0 1-.815.302M8.547 6.561a2.85 2.85 0 0 0-2.149.946 3.4 3.4 0 0 0-.837 2.282 4.85 4.85 0 0 0 1.451 3.153 38 38 0 0 0 3.915 3.6l1.073.911 1.062-.9a38 38 0 0 0 3.925-3.613 4.85 4.85 0 0 0 1.453-3.153 3.4 3.4 0 0 0-.838-2.282 2.85 2.85 0 0 0-2.149-.946 3 3 0 0 0-2.421 1.293 2 2 0 0 0-.123.21.947.947 0 0 1-1.837-.026 2 2 0 0 0-.1-.184 3 3 0 0 0-2.425-1.291",
    "data-name": "Path 10984"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHearti);
export default ForwardRef;